﻿window.cObjetComSmsEnvoiTrackingClickMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "tracking click"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau tracking click"; }
    this.mGetLib1 = function (option) {
        var txt = "Tracking click"   
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "5px" }

    this.alignItemGrid = "right"
    this.mGetIcone = function (dataTemplate) {
        var $Icone = $("<i class='fas fa-arrow-pointer' style='position:relative'><i class='fas fa-mobile-screen-button' style='position:absolute;bottom:0;right:0;font-size:50%;color:" + theme.backgroundcolorAccent + ";'></i></i>");
        $Icone.attr("title", "Tracking click SMS")
        //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Icone, position: "bottom", contentTemplate: function (contentElement) { contentElement.text("Tracking click SMS") } })
        return $Icone
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        option.bddCtrl = Me.objet.bddRef 
        itemTemplateGrilleClickVue(contentElement, dataTemplate, type, dxGrid, option)
    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        var $Span = $("<span style=''><i class='fas fa-arrow-pointer dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        $Span.attr("title", "Cliquer le " + dataPlus.dcr.toFrenchDateTime())

        //if (objet.data.passe2 == "0") $("<span>CLICK ROBOT &bull; </span>").appendTo(contentElement)
        //var $span = $("<span style='font-family:barlow condensed;font-size:120%;'>" + ((objet.data.libelle != objet.data.lien) ? "(" + objet.data.libelle + ") " : "") + "</span>").appendTo(contentElement)
        //var $A = $("<a href='javascript:void(0)'>" + objet.data.lien.decoupe(20) + "</a>").appendTo($span)
        //$A.on("click", function (e) {
        //    e.stopPropagation()
        //    window.open(objet.data.lien, "_blank")
        //})
        //$("<span>  &bull; Click " + objet.data.dcr.toDateIlya(false) + " (" + objet.data.dcr.toFrenchDateTime() + ")</span>").appendTo($span)
    }

    this.hasScrollPopup = function () { return false }
    this.isPopupFullScreen = false
    //this.mShowPopup = function (optionPopup) {
    //    //page.mAddTab(objet.data, optionPopup)
    //    page.mAddPopup(objet.data)
    //}

    this.mGetAdresseEmailDefaut = function () {
        return objet.data.adresse_email
    }

}